import React, { useCallback, useEffect, useState } from 'react';
import { Alert, Button, Card, Spin } from 'antd';
import { ApiServiceV2 } from 'services';

export const safeDownloadUrl = value => {
	try {
		const url = new URL(value);
		return url.protocol === 'https:' && !url.username && !url.password &&
			/^(?:[a-z0-9.-]+\.)?s3(?:[.-][a-z0-9-]+)?\.amazonaws\.com$/.test(url.hostname) ? url.href : null;
	} catch { return null; }
};

const messages = {
	pending: 'El informe está en preparación. Recibirá el correo cuando termine.',
	processing: 'Estamos preparando los documentos del informe.',
	dead: 'No se pudo completar el informe. Contacte al administrador.',
	expired: 'El enlace ha expirado. Genere el informe nuevamente.',
};

export const ArchiveDownloads = ({ view, grant }) => <>
	{view.rowCount === 0 && <Alert type="info" message="El informe no contiene filas. Puede descargar el Excel original." />}
	{view.partial && <Alert type="warning" message={view.downloadedRowCount === 0 ?
		'No se pudo descargar ninguno de los PDFs del informe. Consulte Resultado.xlsx para identificar todos los fallos.' :
		'El ZIP está incompleto. Consulte Resultado.xlsx para identificar los documentos faltantes.'} />}
	{view.hasZip && <Button onClick={() => grant('zip')}>Preparar descarga ZIP</Button>}
	{view.hasWorkbook && <Button onClick={() => grant('xlsx')}>Preparar descarga Excel</Button>}
</>;

export default function ReportDocumentArchive({ match }) {
	const [view, setView] = useState(null);
	const [error, setError] = useState(false);
	const [loading, setLoading] = useState(false);
	const [download, setDownload] = useState(null);
	const jobId = match.params.jobId;
	const refresh = useCallback(() => {
		setLoading(true); setDownload(null);
		return ApiServiceV2.get({ url: `/reports/document-archives/${encodeURIComponent(jobId)}` })
			.then(data => { setView(data); setError(false); })
			.catch(() => setError(true)).finally(() => setLoading(false));
	}, [jobId]);
	useEffect(() => { refresh(); }, [refresh]);
	const grant = format => {
		setLoading(true); setDownload(null);
		ApiServiceV2.post({ url: `/reports/document-archives/${encodeURIComponent(jobId)}/grant`, params: { format } })
			.then(data => {
				const url = safeDownloadUrl(data.url);
				if (!url) throw new Error('Invalid download link');
				setDownload({ url, format }); setError(false);
			}).catch(() => setError(true)).finally(() => setLoading(false));
	};
	return <Card title="Documentos del informe" style={{ margin: 24 }}>
		<Spin spinning={loading}>
			{error && <Alert type="warning" message="El informe no está disponible o no tiene permiso para abrirlo." />}
			{view?.status === 'ready' ? <ArchiveDownloads view={view} grant={grant} /> : view && <Alert type="info" message={messages[view.status] || 'El informe no está disponible.'} />}
			{download && <p><a href={download.url} rel="noopener noreferrer">Descargar {download.format.toUpperCase()}</a> — enlace temporal</p>}
			<Button onClick={refresh}>Actualizar</Button>
		</Spin>
	</Card>;
}
